import { create } from 'zustand';

const useStore = create((set, get) => ({
  graphData: null,
  setGraphData: (data) => set({ graphData: data, loading: false }),
  
  loading: true,
  error: null,
  setError: (error) => set({ error, loading: false }),
  
  selectedNode: null,
  setSelectedNode: (node) => {
    set({ selectedNode: node });
    // Track clicked nodes
    if (node) {
      set((state) => ({
        clickedNodes: new Set([...state.clickedNodes, node.id])
      }));
    }
  },
  
  hoveredNode: null,
  setHoveredNode: (node) => set({ hoveredNode: node }),
  
  // Track which nodes user has clicked
  clickedNodes: new Set(),
  
  showFilters: false,
  toggleFilters: () => set((state) => ({ showFilters: !state.showFilters })),
  
  filters: {
    searchQuery: '',
    categories: [],
    agencies: [],
    minValue: 0,
    maxValue: 100000000,
    dateRange: null
  },
  
  setFilters: (newFilters) => set((state) => ({
    filters: { ...state.filters, ...newFilters }
  })),
  
  resetFilters: () => set({
    filters: {
      searchQuery: '',
      categories: [],
      agencies: [],
      minValue: 0,
      maxValue: 100000000,
      dateRange: null
    }
  })
}));

export default useStore;